module.exports = __webpack_public_path__ + "static/media/reportsInactive.fd6f3090.png";